@if (pagination() && pagination().totalPages > 1) {
  <app-button (click)="onPageChange(pagination().page - 1)" [disabled]="pagination().page === 1"> Prev </app-button>
  @for (page of getPageNumbers(); track page) {
    <app-button [variant]="page === pagination().page ? 'black' : 'ghost'" (click)="onPageChange(page)">
      {{ page }}
    </app-button>
  }
  <app-button (click)="onPageChange(pagination().page + 1)" [disabled]="pagination().page === pagination().totalPages">
    Next
  </app-button>
}
<!-- <div>
        Showing {{ (pagination().page - 1) * pagination().pageSize + 1 }} to
        {{ pageMin }} of
        {{ pagination().total }} projects
    </div> -->
